import React from 'react'
import { pt } from 'common-data/proptypehelpers'
import { Grid } from './Grid'
import { GridCell } from './GridCell'
import { Button } from './Button'

import _ from 'common-tools/LodashHelper'
import styles from './SharedComponent.less'

function equalizeIt (parentEl, childEl) {
  if (parentEl) {
    var els = parentEl.querySelectorAll(childEl)

    if (els.length === 0) {
      return
    }
    var row = []
    var max
    var top

    // eslint-disable-next-line no-inner-declarations
    function setHeights () {
      row.forEach(function (e) {
        e.style.height = max + 'px'
      })
    }

    for (var i = 0; i < els.length; i++) {
      var el = els[i]
      el.style.height = 'auto'
      if (el.offsetTop !== top) {
        // new row detected
        setHeights()
        top = el.offsetTop
        max = 0
        row = []
      }
      row.push(el)
      max = Math.max(max, el.offsetHeight)
    }
    setHeights() // last row
  }
}

export class DataTableView extends React.Component {
  constructor (props) {
    super(props)

    this.gridObserver = null
    this.gridEl = null
  }

  setGridObserver (element) {
    const { equalize = true, equalizeTarget = '*.equalize-watch' } = this.props
    // if no equalize then just exit
    if (!equalize) {
      this.gridObserver = null
      this.gridEl = null
      return
    }

    if (element && !this.gridObserver) {
      // eslint-disable-next-line no-undef
      this.gridObserver = new ResizeObserver((entries) => {
        equalizeIt(element, equalizeTarget)
      })
      this.gridObserver.observe(element)
      this.gridEl = element
    } else if (!element && this.gridObserver) {
      this.gridObserver.disconnect()
      this.gridObserver = null
      this.gridEl = null
    }
  }

  static pt = {
    data: pt.array,
    renderDataItem: pt.func.isRequired,
    onLoadMore: pt.func,
    onSelectionChanged: pt.func,
    onDataItemChangedProcessing: pt.func,
    onDataChangedTest: pt.func,
    onDataChanged: pt.func,
    onDataChangedProcessing: pt.func,
    loading: pt.bool.isRequired,
    cardStyles: pt.string.isRequired,
    children: pt.any
  }

  static defaultProps = {
    loading: false,
    cardStyles: 'Auto' // Fixed, Fluid, Auto
  }

  componentDidUpdate (prevProps) {
    const { data: prevData } = prevProps
    const { data: currentData, onSelectionChanged, onDataItemChangedProcessing, onDataChangedTest, onDataChanged, equalize = true, equalizeTarget = '*.equalize-watch' } = this.props
    const items = {
      prevItems: prevData || [],
      currentItems: currentData || []
    }

    if (_.isFunction(onDataItemChangedProcessing)) {
      const ret = onDataItemChangedProcessing(items.prevItems, items.currentItems)
      items.prevItems = ret.prevItems
      items.currentItems = ret.currentItems
    }

    if (_.isFunction(onSelectionChanged)) {
      let selectedPrevItems = _.filter(items.prevItems, { Selected: true })
      let selectedCurrentItems = _.filter(items.currentItems, { Selected: true })

      if (selectedPrevItems.length !== selectedCurrentItems.length) {
        onSelectionChanged(selectedCurrentItems)
      }
    }

    if (_.isFunction(onDataChanged) & _.isFunction(onDataChangedTest)) {
      let dataPrevItems = _.filter(items.prevItems, onDataChangedTest)
      let dataCurrentItems = _.filter(items.currentItems, onDataChangedTest)

      if (dataPrevItems.length !== dataCurrentItems.length) {
        if (equalize) {
          equalizeIt(this.gridEl, equalizeTarget)
        }
        onDataChanged(dataCurrentItems)
      }
    }

    setTimeout(() => {
      // datagridview stunt
      const ch = this.gridEl.firstChild
      const chw = ch.lastChild
      const rh = this.gridEl.lastChild.firstChild
      const rhw = rh.firstChild
      const rw = this.gridEl.lastChild.lastChild
      const sbxw = ((rw.offsetWidth - rw.clientWidth) + 1)
      const sbyw = ((rw.offsetHeight - rw.clientHeight) + 1)
      const hlc = chw.firstChild.lastChild
      const hlr = rhw.lastChild
      if (hlc) {
        hlc.setAttribute('style', 'min-width:' + (hlc.offsetWidth + sbxw + 'px'))
        hlr.setAttribute('style', 'height:' + (rhw.firstChild.offsetHeight + 'px'))
        hlr.classList.add(styles['marginBottom' + (sbyw)])
      }
    })
  }

  renderDataItem (collection) {
    const rows = []
    // eslint-disable-next-line no-unused-expressions
    collection?.forEach((item, rowIndex) => {
      const rowKey = 'sheet-row-' + rowIndex
      const columns = []
      const keys = Object.keys(item)
      keys.forEach((key, columnIndex) => {
        columns.push(<DataTableViewColumn id={rowKey + '-cell-' + columnIndex} className={'width-100 max-width-100 margin-right-1'}>{item[key]}</DataTableViewColumn>)
      })
      rows.push(
        <DataTableViewRow id={rowKey} className={'flex-container width-100 margin-bottom-1 bg-white'}>
          {columns}
        </DataTableViewRow>
      )
    })
    return rows
  }

  handleLoadMore (results) {
    const { 'data-tid': testId = '', onLoadMore } = this.props

    if (_.isArray(results) === false) {
      return null
    }

    return <Grid marginX>
      <GridCell small={12} className="text-center">
        <Button data-tid={`${testId}_loadmore`} onClick={onLoadMore}><i className="fas fa-caret-down"></i>&nbsp; Load more ...</Button>
      </GridCell>
    </Grid>
  }

  handleDataTableViewScroll (evt) {
    const rw = evt.currentTarget
    const rhw = rw.previousSibling.firstChild
    const ch = rw.parentNode.previousSibling
    const chw = ch.lastChild
    chw.scrollLeft = evt.currentTarget.scrollLeft
    rhw.scrollTop = evt.currentTarget.scrollTop
  }

  render () {
    const { columns, data, hasMore, loading, className } = this.props

    if (loading) {
      return <div key='loading' className={styles.loadingWrapper}>
        <img className="loading-animation-small" src="/content/images/LogoSymbol.png" />
      </div>
    }

    const headerWidth = 35
    const rowHeaderWidth = styles['width' + headerWidth]
    const rowWrapperLeft = styles['left' + headerWidth]

    const dgClassNames = [className, styles.bgWhite, styles.overflowHidden, styles.absolutePosition, styles.dock, styles.dockLeft, styles.dockBottom, styles.dockRight]
    const hClassNames = [styles.absolutePosition, styles.dock, styles.top0, styles.left0, styles.right0, styles.height35, styles.overflowHidden]
    const hcPivotClassNames = [styles.absolutePosition, styles.dock, styles.top0, styles.left0, rowHeaderWidth, styles.height35, styles.zIndex1, styles.borderRight1, styles.borderRightTableBorder]
    const hcwClassNames = [styles.absolutePosition, styles.dock, styles.top0, rowWrapperLeft, styles.right0, styles.height60, styles.overflowXAuto, styles.overflowYHidden, styles.bgTableHeader]
    const hcrClassNames = ['flex-container', 'width-100', 'margin-bottom-1', styles.height35, styles.fontBold]
    const hcClassNames = ['font-bold', 'width-100', 'margin-right-1', styles.minWidth150, styles.height35]
    const rClassNames = [styles.absolutePosition, styles.dock, styles.dockLeft, styles.dockBottom, styles.dockRight, styles.top35]
    const rwClassNames = [styles.absolutePosition, styles.dock, styles.dockBottom, styles.dockRight, styles.top0, rowWrapperLeft, styles.overflowXAuto, styles.overflowYScroll]
    const rhClassNames = [styles.absolutePosition, styles.dock, styles.dockLeft, rowHeaderWidth, styles.overflowHidden, styles.bgTableHeader, styles.zIndex1, styles.borderRight1, styles.borderRightTableBorder]
    const rhwClassNames = [styles.absolutePosition, styles.dock, styles.dockLeft, styles.width60, styles.overflowXHidden, styles.overflowYAuto, styles.bgTableHeader, styles.zIndex1, styles.borderRight1, styles.borderRightTableBorder]
    const rcPivotClassNames = [rowHeaderWidth, styles.height35]

    return (
      <>
        <div ref={this.setGridObserver} className={dgClassNames.join(' ')}>
          {/* data tabular grid column header */}
          <div className={hClassNames.join(' ')}>
            <div className={hcPivotClassNames.join(' ')}></div>
            <div className={hcwClassNames.join(' ')}>
              <DataTableViewRow className={hcrClassNames.join(' ')}>
                {
                  columns?.map((column, columnIndex) => {
                    const columnKey = 'columnheader-' + columnIndex + '-' + column.split(' ').join('-').toLowerCase() + '-column'
                    return (
                      // eslint-disable-next-line react/jsx-key
                      <DataTableViewColumn id={columnKey} key={columnKey} className={hcClassNames.join(' ')}>{column}</DataTableViewColumn>
                    )
                  })
                }
              </DataTableViewRow>
            </div>
          </div>
          <div className={rClassNames.join(' ')}>
            {/* data tabular grid row header */}
            <div className={rhClassNames.join(' ')}>
              <div className={rhwClassNames.join(' ')}>
                {
                  data?.map((row, rowIndex) => {
                    const rowKey = 'rowheader-row-' + rowIndex
                    return (
                      // eslint-disable-next-line react/jsx-key
                      <DataTableViewRow id={rowKey} key={rowKey} className={'flex-container width-100 margin-bottom-1 bg-white'}>
                        <DataTableViewColumn key={rowKey + '-numbered-cell'}>{rowIndex + 1}</DataTableViewColumn>
                      </DataTableViewRow>
                    )
                  })
                }
                <div className={rcPivotClassNames.join(' ')}></div>
              </div>
            </div>
            <div onScroll={this.handleDataTableViewScroll} className={rwClassNames.join(' ')}>
              {this.renderDataItem(data)}
            </div>
          </div>
        </div>
        {
          hasMore
            ? this.handleLoadMore(data)
            : null
        }
      </>
    )
  }
}

export function DataTableViewRow (props) {
  const { children, id, className } = props
  const classNames = [className, styles.marginBottom0]
  return <div id={id} key={id} className={classNames.join(' ')}>{children}</div>
}

export function DataTableViewColumn (props) {
  const { children, id, className } = props
  const classNames = ['grid-x align-middle', styles.minHeight25, className, styles.minWidth150, styles.white, styles.marginRight0, styles.paddingLeft10, styles.overflowEllipsis, styles.borderRight1, styles.borderRightTableBorder, styles.borderBottom1, styles.borderBottomTableBorder]
  return <div id={id} key={id} className={classNames.join(' ')}>{children}</div>
}
